export const quoteBg = require('./quote-bg.png?webp');
